import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/dreamscape.css';
import './i18n/config'; // Initialize i18n
import App from './App';

// Start in the right theme so the page doesn't flash: the saved choice for a signed-in
// writer, otherwise the device's. ThemeContext takes over once the app mounts.
(() => {
  let saved: string | null = null;
  try {
    saved = localStorage.getItem('accessToken') ? localStorage.getItem('theme') : null;
  } catch {
    // storage blocked: follow the device
  }
  const dark =
    saved === 'dark' ||
    (saved !== 'light' && window.matchMedia('(prefers-color-scheme: dark)').matches);
  document.documentElement.classList.add(dark ? 'dark' : 'light');
})();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
